import React, { useState, useEffect } from "react";
import { Client } from "boardgame.io/react";
import { DungeonThrowdown } from "../components/Game";
import { Board } from "../components/Board";
import { motion, AnimatePresence } from "framer-motion";

const Demo = Client({
  game: DungeonThrowdown,
  board: BoardDisplay,
  debug: false,
});

function BoardDisplay({ G, ctx, moves, events, playerID, reset }) {
  const [gameMessage, setGameMessage] = useState(G.messages.game);
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    // Update gameMessage whenever G or ctx changes
    // setShowMessage(false);
    setGameMessage(G.messages.game);
    // setShowMessage(true);
  }, [G.messages.game]);

  // console.log("playerID", playerID);

  return (
    <div id="board-display">
      {/* <AnimatePresence> */}
      {G.messages.game && showMessage && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="game-message"
        >
          {gameMessage}
        </motion.p>
      )}
      {/* </AnimatePresence> */}
      <Board G={G} ctx={ctx} moves={moves} events={events} />
    </div>
  );
}

export default Demo;
